import React, {Component} from 'react';
import {request} from "../../../helper/APIUtils";
import {showAxiosError} from "../../../helper/helper";
import Alert from "react-s-alert";
import SweetAlert from 'react-bootstrap-sweetalert';

class SendMail extends Component {

	constructor(props) {
		super(props);

		this.state = {
			style: 'fas fa-at',
			alert: null
		}
	}

	handleSendMail(content) {
		if (content && content.username.endsWith("_eczpos")) {
			this.setState({
				alert: (
					<SweetAlert warning
								confirmBtnText="Tamam"
								confirmBtnBsStyle="warning"
								title="Uyarı"
								onConfirm={() => this.setState({alert: null})}
					>
						{'Eczacipos kullanıcı şifre değişim işlemleri için lütfen eczacıpos destek ekibiyle iletişime geçiniz.'}
					</SweetAlert>
				)
			});
		} else {
			const confirm = () => {
				this.setState({style: 'fas fa-spinner fa-spin'})
				let self = this;
				let params = {
					url: `/user/sendNewMail`,
					method: 'post',
					data: content.recordId
				};
				request(params).then(function (response) {
					Alert.warning('İsteğiniz sıraya alınmıştır.', {
						position: 'top-right',
						effect: 'stackslide',
						offset: 100,
						timeout: 5000,
						html: false
					});
					self.setState({style: 'fas fa-at', alert: null});
					self.props.newMailSendRequestSuccess();
				}).catch(function (error) {
					self.setState({style: 'fas fa-at', alert: null})
					showAxiosError(error);
				});
			};

			this.setState({
				alert: (
					<SweetAlert showCancel warning
								confirmBtnText="Onayla"
								cancelBtnText="İptal"
								confirmBtnBsStyle="danger"
								cancelBtnBsStyle="default"
								title="Emin misiniz?"
								onConfirm={() => confirm()}
								onCancel={() => this.setState({alert: null})}
					>
						{'Giriş bilgileri ' + content.email + ' adresine yeniden gönderilecek.'}
					</SweetAlert>
				)
			});
		}
	}

	render() {
		return (
			<span>
				{this.state.alert}
				<button type="button"
						onClick={() => this.handleSendMail(this.props.item)}
						data-toggle="tooltip" data-placement="bottom" title="Tekrar e-Posta Gönder"
						style={{background: 'rgb(255, 180, 88)'}}
						rel="tooltip" className="Btn btn-sm btn-icon">
					<i className={this.state.style}></i>
				</button>
			</span>
		)
	}
}

export default SendMail;